import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeDocumentsDisplayModel } from "../../store/slices/modalSlice";
import { Modal } from "react-bootstrap";
import axiosInstance from "../../api/axiosInstance";
import { RootState } from "../../store/store";
import { setFromDeleteDoc } from "../../store/slices/IdSlice";
interface FileEntry {
  applicantName: string;
  storedName: string;
  originalName?: string;
  label?: string;
  isGroup?: number | 0;
  RecordId: number;
}

const DocumentsDisplayModel: React.FC = () => {
  const dispatch = useDispatch();
  const [documentUrl, setDocumentUrl] = useState<string>("");
  const [activeIndex, setActiveIndex] = useState<number>(0);

  const openModel = useSelector(
    (state: { modal: { documentsDisplayModel: boolean } }) =>
      state.modal.documentsDisplayModel
  );
  const fromDeleteDoc = useSelector(
    (state: RootState) => state.ID.fromDeleteDoc
  );

  const documentData = useSelector(
    (state: {
      modal: {
        documentData: { files: FileEntry[] } | null;
      };
    }) => state.modal.documentData
  );
  const closeModel = () => {
    dispatch(setFromDeleteDoc(false));
    dispatch(closeDocumentsDisplayModel());
    setDocumentUrl("");
    setActiveIndex(0);
  };
  const activeFile = documentData?.files?.[activeIndex];

  useEffect(() => {
    const fetchData = async () => {
      if (!activeFile) return;

      try {
        const response = await axiosInstance.get(
          `/api/applicantUpload/download/${activeFile.applicantName}/${activeFile.storedName}`,
          {
            responseType: "blob",
          }
        );

        if (response.data) {
          const blob = new Blob([response.data], {
            type:
              response.headers["content-type"] || "application/octet-stream",
          });
          const url = URL.createObjectURL(blob);
          setDocumentUrl(url);
        }
      } catch (error) {
        console.error("Error fetching document:", error);
      }
    };
    if (!fromDeleteDoc) fetchData();
  }, [activeFile]);
  const [UUID, setUUID] = useState<string>("");
  useEffect(() => {
    const uuidd = localStorage.getItem("uuid");

    if (uuidd) {
      setUUID(uuidd);
    }
  }, []);
  const handleDeleteFile = async (mainFileId: number) => {
    if (mainFileId > 0 && activeFile) {
      try {
        const response = await axiosInstance.delete(
          `/api/applicantUpload/deleteApplicantDoc`,
          {
            params: {
              UUID,
              mainFileId,
              applicantName: activeFile.applicantName,
            },
          }
        );

        if (response.data) {
          window.location.href = window.location.href;
        }
      } catch (error) {
        console.error("Error deleting item:", error);
      }
    }
    return;
  };

  const isPDF = activeFile?.storedName?.toLowerCase().endsWith(".pdf");
  const isImage = activeFile?.storedName
    ?.toLowerCase()
    .match(/\.(jpg|jpeg|png|gif)$/);

  return (
    <>
      <Modal
        centered
        show={openModel}
        onHide={closeModel}
        backdrop="static"
        className="mb-fix slide-from-bottom "
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="rounded-top">
          {!fromDeleteDoc ? (
            <div className=" d-flex flex-column h-100">
              <div className="text-center mb-4">
                {activeFile && (
                  <div className="text-start mb-4">
                    <p className="font-16 ff-semibold">
                      {activeFile.storedName}
                    </p>
                  </div>
                )}

                {documentData && documentData?.files?.length && (
                  <div className="d-flex justify-content-center my-3">
                    {documentData.files.map(
                      (file, index) =>
                        file.isGroup !== 0 && (
                          <button
                            key={index}
                            className={`document-toggle-btn ${
                              activeIndex === index ? "active" : ""
                            } ${index === 0 ? "first" : ""} ${
                              index === documentData.files.length - 1
                                ? "last"
                                : ""
                            }`}
                            onClick={() => setActiveIndex(index)}
                          >
                            {/* {index === 0 ? "Front" : "Back"} */}
                            {file.label}
                          </button>
                        )
                    )}
                  </div>
                )}
                {documentUrl && (
                  <div className="document-preview bg-2 rounded-3">
                    {isPDF ? (
                      <iframe
                        src={documentUrl}
                        width="100%"
                        height="500px"
                        title="PDF Preview"
                      />
                    ) : isImage ? (
                      <div className="image-container border-0">
                        <img
                          src={documentUrl}
                          alt="Document Preview"
                          style={{
                            maxWidth: "100%",
                            height: "270px",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                    ) : (
                      <p>Unsupported file format</p>
                    )}
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="d-flex flex-column h-100">
              <div>
                <img
                  src="https://goodhand.b-cdn.net/Assets/Flow/delte.svg"
                  alt=""
                  className="mx-auto d-block mb-2"
                />
                <p className="text-center font-13 text-dark ff-medium">
                  Are you sure, you want to delete ?
                </p>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="p-0 border-0 rounded-0 shadow-none border-top modal-footer rounded-bottom">
          {fromDeleteDoc && (
            <div className="d-flex align-items-center justify-content-between w-100 px-3 py-2 gap-3">
              <button
                className="btn btn-primary bg-2 w-100 font-14 ff-semibold py-3 text-black  bt--cart"
                onClick={closeModel}
              >
                NO
              </button>
              <button
                className="btn btn-primary w-100 font-14 ff-semibold py-3 bt--cart bg-red"
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteFile(documentData?.files[0]?.RecordId ?? 0);
                }}
              >
                YES, DELETE
              </button>
            </div>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DocumentsDisplayModel;
